"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IODynamicPackage = exports.getDynamicPackageAttributeHash = exports.ctDynamicPackageListFetch = void 0;
const fluture_1 = require("fluture");
const ramda_1 = require("ramda");
const commercetoolsClient_1 = require("../commercetools/commercetoolsClient");
const products_1 = require("../commercetools/products");
const commercetools_1 = require("../secrets/commercetools");
const errorLogging_1 = require("../thirdparty/errorLogging");
const ctDynamicPackageListFetch = (request) => (0, commercetoolsClient_1.commercetoolsFetch)({
    body: JSON.stringify(request),
    endpoint: `${commercetools_1.productUrl}/dynamic-packages/shopping-list`,
    method: 'POST'
});
exports.ctDynamicPackageListFetch = ctDynamicPackageListFetch;
const getDynamicPackageAttributeHash = (request) => (0, commercetoolsClient_1.commercetoolsFetch)({
    body: JSON.stringify(request),
    endpoint: `${commercetools_1.productUrl}/dynamic-packages/attribute-hash`,
    method: 'POST'
});
exports.getDynamicPackageAttributeHash = getDynamicPackageAttributeHash;
// Note: Used on the new @site/shop PDP pages. Similar to IOMiniCart without any Redux functionality.
const IODynamicPackage = (attributeHash, locale, handleFailure, handleSuccess) => ((0, products_1.commerceToolsRequestDynamicPackageList)(locale)(attributeHash)
    .pipe((0, fluture_1.map)(response => response.map((0, ramda_1.prop)('lineItems')).getOrElse([])))
    .pipe((0, fluture_1.map)(lineItems => lineItems.map(lineItem => ({
    quantity: lineItem.quantity,
    sku: lineItem.custom.fields.master_sku
}))))
    .pipe((0, fluture_1.fork)((error) => {
    (0, errorLogging_1.logError)(error);
    handleFailure && handleFailure(error);
})(items => handleSuccess && handleSuccess(items))));
exports.IODynamicPackage = IODynamicPackage;
//# sourceMappingURL=index.js.map